import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { GoogleLogout } from 'react-google-login';
import { Badge } from 'antd';
import { InfoWraper } from './auth-info-style';
import { logOut } from '../../../redux/authentication/actionCreator';
import { useNotification } from '../../../_helpers/NotificationContext';

const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

const AuthInfo = () => {
  const dispatch = useDispatch();
  const { notificationCount, resetNotificationCount } = useNotification();

  const googleLogoutRef = useRef(null);

  const SignOut = e => {
    e.preventDefault();
    dispatch(logOut());
  };

  const handleBellIconClick = () => {
    resetNotificationCount();
  };

  return (
    <InfoWraper style={{ position: 'relative' }}>
      <div className="nav-author">
        <Badge count={notificationCount} style={{ fontSize: '11px', display: 'flex', alignItems: 'center' }}>
          {/* <Badge count={50} style={{ fontSize: '11px', display: 'flex', alignItems: 'center' }}> */}
          <FeatherIcon
            style={{ marginRight: '5px', marginTop: '2px', cursor: 'pointer' }}
            icon="bell"
            size={16}
            onClick={handleBellIconClick}
          />
        </Badge>

        <GoogleLogout
          clientId={clientId}
          onLogoutSuccess={() => {
            dispatch(logOut());
            // resetNotificationCount();
          }}
          render={({ onClick }) => (
            <div onClick={onClick}>
              <Link
                style={{ display: 'flex', alignItems: 'center' }}
                className="user-dropdwon__bottomAction"
                onClick={SignOut}
                to="#"
              >
                <FeatherIcon style={{ marginRight: '5px' }} icon="log-out" size={16} />
                <span>Déconnexion</span>
              </Link>
            </div>
          )}
          ref={googleLogoutRef}
        />
      </div>
    </InfoWraper>
  );
};

export default AuthInfo;
